module.exports = __webpack_public_path__ + "static/media/AZFMC_logo.2c1de45d.png";